import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b155f6b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "external-examiner-main" }
const _hoisted_2 = {
  key: 1,
  class: "wrapper"
}
const _hoisted_3 = {
  class: "control",
  title: "Toggle options menu"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-left" })
], -1))
const _hoisted_5 = {
  key: 0,
  class: "text"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "heading" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-text" }, "External Examiner details", -1))
const _hoisted_9 = { class: "info-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "LawID", -1))
const _hoisted_11 = { class: "fielddata" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "LawID Email", -1))
const _hoisted_13 = { class: "fielddata" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Last name", -1))
const _hoisted_15 = { class: "fielddata" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "First name", -1))
const _hoisted_17 = { class: "fielddata" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Status", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Email", -1))
const _hoisted_20 = { class: "fielddata" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Firm name", -1))
const _hoisted_22 = { class: "fielddata" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Address", -1))
const _hoisted_24 = { class: "fielddata" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Suburb", -1))
const _hoisted_26 = { class: "fielddata" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Postcode", -1))
const _hoisted_28 = { class: "fielddata" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "State", -1))
const _hoisted_30 = { class: "fielddata" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Telephone number", -1))
const _hoisted_32 = { class: "fielddata" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Membership type", -1))
const _hoisted_34 = { class: "fielddata" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Publish on Web", -1))
const _hoisted_36 = { class: "fielddata" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Proof of External Examiner Course Completion")
], -1))
const _hoisted_39 = { class: "file-list" }
const _hoisted_40 = { class: "file mb-2" }
const _hoisted_41 = { class: "file-name" }
const _hoisted_42 = { class: "file-actions" }
const _hoisted_43 = { class: "action" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "right-panel" }

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_router_view = _resolveComponent("router-view")
  const _component_AddEeModal = _resolveComponent("AddEeModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.validatingEntrance)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(['left-panel', _ctx.hidePracticeInfo ? 'hideInfo': ''])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "hide-options",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.showHideOptions(_ctx.hideLeftPanel)))
              }, [
                _hoisted_4,
                (!_ctx.hidePracticeInfo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Hide Options"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.hideLeftPanel)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "show-options",
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.showHideOptions(_ctx.hideLeftPanel)))
                  }, [
                    _createTextVNode(" Show"),
                    _hoisted_6,
                    _createTextVNode("Options ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.hidePracticeInfo)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("button", {
                      class: "btn btn-outline sml",
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.editEE()))
                    }, "Edit")
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedEE.lawId), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.selectedEE.email), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_14,
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.selectedEE.lastName), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectedEE.firstName), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_18,
                      _createElementVNode("span", {
                        class: _normalizeClass(["fielddata", _ctx.selectedEE.inactive ? 'inactive' : 'active'])
                      }, _toDisplayString(_ctx.selectedEE.inactive ? 'Inactive' : 'Active'), 3)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.selectedEE.email ?? '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_21,
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.selectedEE.firmName), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_23,
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.selectedEE.address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.selectedEE.suburb), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_27,
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.selectedEE.postCode), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_29,
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.selectedEE.state), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.selectedEE.phoneDetail?.countryCode) + " " + _toDisplayString(_ctx.selectedEE.phoneDetail?.phoneNumber), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_33,
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.selectedEE.eeMembershipType?.name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_35,
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.selectedEE.publishOnWeb? 'Yes' : 'No'), 1)
                    ]),
                    _hoisted_37,
                    _hoisted_38
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEE.files, (file) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", null, _toDisplayString(file.fileName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("button", {
                              class: "btn btn-secondary sml",
                              onClick: $event => (_ctx.downloadFile(file))
                            }, "Download", 8, _hoisted_44)
                          ])
                        ])
                      ]))
                    }), 256))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_router_view)
          ])
        ])),
    (_ctx.showAddEEModal)
      ? (_openBlock(), _createBlock(_component_AddEeModal, {
          key: 2,
          onCloseEEModal: _cache[3] || (_cache[3] = $event => (_ctx.showAddEEModal = false)),
          selectedEE: _ctx.selectedEE,
          "onUpdate:selectedEE": _cache[4] || (_cache[4] = $event => ((_ctx.selectedEE) = $event)),
          onUpdateEE: _ctx.loadEE
        }, null, 8, ["selectedEE", "onUpdateEE"]))
      : _createCommentVNode("", true)
  ]))
}